<template>
  <v-container class="my-12 px-4">
    <v-row justify="center">
      <v-col cols="12" class="px-2 text-center">
        <h1>
          {{ loginDescription.title }}
        </h1>
        <p class="mb-0">{{ loginDescription.description }}</p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="5" class="px-2">
        <SignInForm />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SignInForm from "@/components/SignInForm.vue";
import { useTranslation } from "@/plugins/i18next/i18next";
import {
  defineComponent,
  computed,
  getCurrentInstance,
  onBeforeMount
} from "vue";
import { useRouter } from "vue-router/composables";

export default defineComponent({
  name: "LoginAccessRequired",
  components: { SignInForm },
  props: {
    normalLoginScreen: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useTranslation();
    const instance = getCurrentInstance().proxy;
    const router = useRouter();

    onBeforeMount(() => {
      // component is resued for required sign in which has own flow logic in plugins/router/index.js
      if (props.normalLoginScreen && instance.$auth.isAuthenticated) {
        router.replace({
          name: "PersonProfilePage",
          params: {
            personId: instance.$auth.user.id
          }
        });
      }
    });

    const loginDescription = computed(() => {
      if (props.normalLoginScreen) {
        return {
          title: t("common:welcomeAndLogin.heading", "Welcome to Equibel!"),
          description: t(
            "common:welcomeAndLogin.hint",
            "Login is required to enter competitions, manage your entries, licences and data. You may browse Calendar and other information without being logged in."
          )
        };
      }
      return {
        title: t(
          "common:errorMessage.accessRequiresLoggedIn.text",
          "Access requires to be logged in"
        ),
        description: t("common:errorMessage.logIn.text", "Please log in!")
      };
    });

    return {
      loginDescription
    };
  }
});
</script>
